module.exports = __webpack_public_path__ + "static/img/业务-1.6a6d8448.png";